import styled from "styled-components";

export const MainWrapDiv = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & > div:first-child {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 12px;
    color: #118d8b;
  }
`;